import React from "react"

const Logo = () => {
	return (
		<>
			<img src="/images/logo-rackext-svgrepo-com.svg" draggable="false" alt="logo" />
		</>
	)
}

export default Logo